import TagManager from 'react-gtm-module';

const pushGTMEvent = (title) => {
  const tagManagerArgs = {
      gtmId: 'GTM-W4GXFPH',
      dataLayer: {
        event: 'analyticsVPV',
        transactionWidgetPageURL: `/CM/${title}`,
        transactionWidgetPageTitle: `CM - ${title.replace(/\//g, ':')}`,
      },
  };

  TagManager.initialize(tagManagerArgs);
};

export default pushGTMEvent;
